// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".leaflet-popup-content-wrapper{border:1px solid #d1bc9d;border-radius:0;box-shadow:none;overflow:hidden;padding:0!important}.leaflet-popup-content{margin:0!important}.leaflet-container a{color:inherit!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
